export const annualRevenueMap: { [key: string]: number } = {
  'Less than $250K': 125000,
  '$250K to $500K': 375000,
  '$500K to $1M': 750000,
  '$1M to $2M': 1500000,
  '$2M to $5M': 3500000,
  '$5M to $10M': 7500000,
  '$10M+': 10000000,
} as const

export const debtMap: { [key: string]: number } = {
  'No Debt': 0,
  'Less than $10,000': 5000,
  '$10,000-$25,000': 17500,
  '$25,000-$50,000': 37500,
  '$50,000-$100,000': 75000,
  '$100,000-$250,000': 125000,
  '$250,000-$500,000': 375000,
  '$500,000-$1,000,000': 750000,
  'More than $1,000,000': 1000000,
} as const

export const netProfitMap = {
  'No Profit': 0,
  'Less than $100K': 50000,
  '$100K- $250K': 175000,
  '$250K- $500K': 375000,
  '$500K- $750K': 625000,
  '$750K- $1M': 875000,
  '$1M-$2M': 1500000,
}

export const maxOrderVolumeMap = {
  'Less than $50,000': '50000',
  '$50,001 to $75,000': '75000',
  '$75,001 to $100,000': '100000',
  '$100,001 to $125,000': '125000',
  '$125,001 to $150,000': '150000',
  'More than $150,000': '200000',
}

export const orderVolumeMap = {
  'Less than $500': '500',
  '$501 to $2,000': '2000',
  '$2,001 to $5,000': '5000',
  '$5,001 to $10,000': '10000',
  '$10,001 to $30,000': '30000',
  'More than $30,000': '40000',
}

export const saleVolumeMap = {
  'Less than $1M': '1000000',
  '$1M-$2M': '2000000',
  '$2M-$5M': '5000000',
  '$5M-$20M': '20000000',
  '$20M-$50M': '50000000',
  '$50M-$100M': '80000000',
  'More than $100M': '100000000',
}

export const refundPolicyMap = {
  'No Refund': 'N',
  'Merchandise Exchange Only': 'E',
  '30 Days or Fewer': 'T',
  Other: 'O',
}

export const companyTypesMap = {
  'Association/Estate/Trust': 'A',
  'Government (Federal/State/Local)': 'G',
  'Sole Proprietorship': 'S',
  'Financial Institution': 'F',
  LLC: 'L',
  'Tax-Exempt Organization (501C)': 'E',
  Partnership: 'P',
  'Private Corporation': 'V',
  'Public Corporation': 'B',
  'SEC-Registered Entity': 'R',
}
